module.exports = __webpack_public_path__ + "static/media/1.1c00961d.jpg";